module.exports = __webpack_public_path__ + "img/clogo.1a1c505e.png";